'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_RecipeParsingResults(recipe, errorList, cleanHtml, requiresExtension, unparsable) {
  this.m4 = null;
  this.oC = null;
  this.rl = null;
  this.uD = false;
  this.sL = false;
  this.m4 = recipe;
  this.oC = errorList;
  this.rl = cleanHtml;
  this.uD = requiresExtension;
  this.sL = unparsable;
}
export { $c_Lmealorama_RecipeParsingResults as $c_Lmealorama_RecipeParsingResults };
$p = $c_Lmealorama_RecipeParsingResults.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_RecipeParsingResults;
/** @constructor */
function $h_Lmealorama_RecipeParsingResults() {
}
export { $h_Lmealorama_RecipeParsingResults as $h_Lmealorama_RecipeParsingResults };
$h_Lmealorama_RecipeParsingResults.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 806886516);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.m4));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.oC));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.rl));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.uD ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.sL ? 1231 : 1237));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 5);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_RecipeParsingResults)) {
    if (((this.uD === x$0.uD) && (this.sL === x$0.sL))) {
      var x = this.m4;
      var x$2 = x$0.m4;
      var $x_2 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.oC;
      var x$4 = x$0.oC;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.rl;
      var x$6 = x$0.rl;
      return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 5;
});
$p.r = (function() {
  return "RecipeParsingResults";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.m4;
      break;
    }
    case 1: {
      return this.oC;
      break;
    }
    case 2: {
      return this.rl;
      break;
    }
    case 3: {
      return this.uD;
      break;
    }
    case 4: {
      return this.sL;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_RecipeParsingResults(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jN)));
}
export { $isArrayOf_Lmealorama_RecipeParsingResults as $isArrayOf_Lmealorama_RecipeParsingResults };
var $d_Lmealorama_RecipeParsingResults = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_RecipeParsingResults, "mealorama.RecipeParsingResults", ({
  jN: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_RecipeParsingResults as $d_Lmealorama_RecipeParsingResults };
//# sourceMappingURL=mealorama.-Recipe-Parsing-Results.js.map
